<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3 w-100">
      <h4 class="title"><i class="fas fa-envelope-open-text"></i> {{title | translate}}</h4>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-3 custom-mr-13" *ngIf="hasRole(ROLE_SUPERADMIN)">
    <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}:</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-university"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="searchBatchloading.partnerId"
              (ngModelChange)="change()">
        <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name | translate}}</option>
      </select>
    </div>
  </div>
  <div class="col-md-3" *ngIf="hasRole(ROLE_PARTNER) || hasRole(ROLE_SUPERADMIN)">
    <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text"><i class="fa fa-building"></i></div>
      </div>
      <select class="form-control"
              [(ngModel)]="searchBatchloading.enterpriseId"
              (ngModelChange)="search()">
        <option *ngFor="let enterprise of enterprises"
                [ngValue]="enterprise.id">{{ enterprise.name | translate }}</option>
      </select>
    </div>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead>
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}" *ngIf="hasRole(ROLE_PARTNER)"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.WORKFLOW' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.CODE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DATE-AT' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let batchloading of batchloadings; let index=index"
        class="{{hasRole(ROLE_PARTNER)?'custom-font-size-table-body':'custom-font-size-table-body-isnt-partner'}}">
      <td title="#">{{(page.number * pageNumber) + index + 1}}</td>
      <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"
          *ngIf="hasRole(ROLE_PARTNER)">{{batchloading.enterpriseName}}</td>
      <td title="{{ 'TABLE.HEADER.RESPONSIBLE' | translate }}">{{batchloading.fullnamePerson}}</td>
      <td title="{{ 'TABLE.HEADER.WORKFLOW' | translate }}">{{batchloading.workflowDescription}}</td>
      <td title="{{ 'TABLE.HEADER.CODE' | translate }}">{{batchloading.code}}</td>
      <td title="{{ 'TABLE.HEADER.DATE-AT' | translate }}">{{batchloading.createAt | dateformat}}</td>
      <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
        <span
          class="{{!batchloading.active? 'badge badge-danger':''}}">{{batchloading.active ? 'Activo' : 'Inactivo'}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
        <div class="dropdown">
          <button type="button" class="btn btn-default " id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item poniter"
                    (click)="openDetailModal(batchloading)">
              <i class="fa fa-align-left"></i> {{ "BUTTON.SEE-DETAIL" | translate }}
            </button>
            <button class="dropdown-item poniter"
                    (click)="getDocumentsNotify(batchloading)">
              <i class="fa fa-file-excel"></i> {{ "BUTTON.EXPORT-DETAIL" | translate }}
            </button>
            <button class="dropdown-item poniter"
                    *ngIf="hasAcknowledgment(batchloading)"
                    (click)="getBatchAcknowledgment(batchloading)">
              <i class="fa fa-download"></i> {{ "BUTTON.DOWNLOAD-BATCH-ACKNOWLEDGMENT" | translate }}
            </button>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <span class="mr-1 font-weight-normal">Mostrar </span>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadBatchLoadings(enumPage.First,searchBatchloading.partnerId, searchBatchloading.enterpriseId)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <span class="font-weight-normal"> registros.</span>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{batchloadings.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadBatchLoadings(enumPage.First,searchBatchloading.partnerId, searchBatchloading.enterpriseId)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left" (click)="loadBatchLoadings(enumPage.Previous,searchBatchloading.partnerId, searchBatchloading.enterpriseId)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadBatchLoadings(enumPage.Next,searchBatchloading.partnerId, searchBatchloading.enterpriseId)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
            (click)="loadBatchLoadings(enumPage.Last,searchBatchloading.partnerId, searchBatchloading.enterpriseId)">
          <a class="next">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading"></app-loading>
